import { ContactMedium } from '../../generated/api/contactMedium.js';
import type { CustomerResponse } from '../../generated/api/customerResponse.js';
import type { DeliveryAddress } from '../../generated/api/deliveryAddress.js';

export interface GeographicAddressCharacteristic {
  addressId: string;
  street1: string;
  city: string;
  postCode: string;
  country: string;
  stateOrProvince?: string;
  recipientName?: string;
  phoneNumber?: string;
}

export const getCustomerPrimaryAddress = (customer: CustomerResponse): GeographicAddressCharacteristic | undefined => {
  const geographicMedium = customer.contactMedium?.find(
    (cm: ContactMedium) => cm.mediumType === ContactMedium.MediumTypeEnum.postalAddress
  );
  if (!geographicMedium) {
    return undefined;
  }
  return geographicMedium.characteristic as GeographicAddressCharacteristic;
};

export const mapCustomerAddressToDeliveryAddress = (
  geoAddress: GeographicAddressCharacteristic,
  companyName: string
): DeliveryAddress => ({
  companyName,
  recipient: geoAddress.recipientName ?? '',
  phoneNumber: geoAddress.phoneNumber ?? '',
  address: {
    line1: geoAddress.street1,
    line2: '',
    postalCode: geoAddress.postCode,
    postOffice: geoAddress.city,
    countryCode: geoAddress.country,
  },
});
